module.exports = {"TXTWCL_Star_Sub_enabled_selection":{"id":"TXTWCL_Star_Sub_enabled_selection","defaultMessage":"スター サブが有効な選択肢"}}